import type { ReactNode } from 'react';

/**
 * Friendly empty state with optional next-action call-to-action.
 * Replaces bare "No people match" text. Per the visual brief: every
 * empty state should explain why and offer the next step.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className = '',
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center px-6 py-12 text-center ${className}`}
    >
      {icon ? (
        <div
          aria-hidden
          className="mb-3 flex h-12 w-12 items-center justify-center rounded-token-sm bg-accent/10 text-accent"
        >
          {icon}
        </div>
      ) : null}
      <h3 className="text-base font-semibold text-fg">{title}</h3>
      {description ? (
        <p className="mt-1 max-w-sm text-sm text-fg-muted">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
